// Single source of truth for the workshop price.
//
// Both the frontend (order summary / display) and the backend (order
// creation + payment verification) import this so they can never
// accidentally disagree.
//
// IMPORTANT: the backend is always the sole authority on what a payment
// must be for. The value here is used server-side to create the Razorpay
// order and to verify the captured payment amount; it is never overridden
// by anything supplied by the browser.

export const CURRENCY = 'INR';
export const WORKSHOP_PRICE_INR = 199;
export const WORKSHOP_AMOUNT_PAISE = WORKSHOP_PRICE_INR * 100;
